import React from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router';
import { checkIsActive, KTSVG } from '../../../helpers';
import { useLayout } from '../../core';

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: JSX.Element | string;
  hasBullet?: boolean;
  linkId?: string;
};

const AsideMenuItemWithSub: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  linkId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { aside } = config;

  return (
    <div
      className={clsx('menu-item', { 'here show': isActive }, { 'menu-accordion': true })}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link menu-item-with-sub-parent' id={linkId?.replaceAll(' ', '_')}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {fontIcon && typeof fontIcon === 'string' ? (
          <span className='menu-icon'>
            <i className={fontIcon + ' mx-2'}></i>
          </span>
        ) : (
          fontIcon
        )}
        {!fontIcon && icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
        {children}
      </div>
    </div>
  );
};

export { AsideMenuItemWithSub };
